import { Vertical } from './vertical';
import { AssetConfig } from './asset-config';

export const ADMIN_KEY = 'ADMIN';

export const SUPER_ADMIN_TENANT: Tenant = {
  id: ADMIN_KEY,
  title: 'Super Admin',
  isActive: true,
};

export enum TenantType {
  AUTHENTICATION = 'authentication',
  IDENTIFICATION = 'identification',
  CLASSIFICATION = 'classification',
}

interface TenantPublicMetadata {
  [key: string]: any;

  demoMode?: {
    enabled: boolean;
    defaultSkuSerialId: string;
  };

  debugMode?: {
    enabled?: boolean;
  };

  // Schema-driven asset config (fields + layout). Tenant-level default; a SKU can override it.
  assetConfig?: AssetConfig;

  // Named capture flows in the Origin Identity menu, each recording its own provenance events.
  originFlows?: import('./provenance').OriginIdentityFlow[];

  // Tenant-wide default L2 distance cutoff for image classification (0..2). Overrides the built-in
  // 0.9; a flow's own classification.threshold overrides this in turn.
  classificationThreshold?: number;

  // Identification policy (tenant-wide, never per-SKU). `minFingerprints` is the minimum registered
  // items a SKU needs before identification is offered/attempted (default 3, see
  // config/identification.ts).
  identification?: {
    minFingerprints?: number;
  };
}

export interface Tenant {
  id: string;
  title: string;
  allowedVerticals?: Vertical[];
  publicMetadata?: TenantPublicMetadata;
  createdAt?: Date;
  updatedAt?: Date;
  isActive: boolean;
}

export interface UserTenants {
  userId: string;
  tenants: Tenant[];
}

export interface UserTenant {
  userId: string;
  tenant: Tenant;
}

export interface TenantsResponseData {
  tenants: Tenant[];
  activeTenants?: Tenant[];
}
